// A section's UI strings: one file in i18n/areas/ holds both languages of one area of Messages
// (Messages[key]). It ends with
//
//   export const area = defineArea('key', keyFi, keyEn);
//   declare module '../area' {
//     interface AreaMessages extends Record<typeof area.key, typeof keyFi> {}
//   }
//
// i18n/area-registry.ts collects the areas (import.meta.glob) and fi.ts / en.ts add them to the
// core strings, so a new area needs no edit anywhere else; the augmentation puts its type into
// Messages. A file in areas/ without `area` (a part another area imports) is skipped.

/** The areas' strings by key (filled by each area file through module augmentation). */
export interface AreaMessages {}

export interface Area<K extends string = string, T = unknown> {
  readonly key: K;
  readonly fi: T;
  readonly en: T;
}

/** One area: its key in Messages and its strings in Finnish and English (the same shape). */
export const defineArea = <K extends string, T>(key: K, fi: T, en: NoInfer<T>): Area<K, T> => ({ key, fi, en });
